import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Loader from "@/components/Loader";
import Home from "@/pages/Home";
import BookingPage from "@/pages/BookingPage";
import ProjectDetail from "@/pages/ProjectDetail";
import WorkPage from "@/pages/WorkPage";
import ContactPage from "@/pages/ContactPage";
import PolicyPage from "@/pages/PolicyPage";
import AdminApp from "@/pages/admin/AdminApp";
import AuthCallback from "@/pages/AuthCallback";
import NotFound from "@/pages/NotFound";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/work" element={<WorkPage />} />
      <Route path="/work/:slug" element={<ProjectDetail />} />
      <Route path="/project/:slug" element={<ProjectDetail />} />
      <Route path="/book" element={<BookingPage />} />
      <Route path="/quote" element={<BookingPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/privacy" element={<PolicyPage which="privacy" />} />
      <Route path="/terms" element={<PolicyPage which="terms" />} />
      <Route path="/booking-policy" element={<PolicyPage which="booking-policy" />} />
      <Route path="/admin" element={<AdminApp />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Loader />
          <AppRouter />
          <Toaster position="top-center" theme="dark" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
